<!-- 社会招聘 -->
<template>
  <div class='template-container'>
    <div class="template-header">
      <div class="main-item">
        <router-link to="join-us"
                     class="item-span">{{$t('join_social.text1')}}</router-link>
      </div>
      <div class="main-item">
        <router-link to="social"
                     class="item-span item-active">{{$t('join_social.text2')}}</router-link>
      </div>
      <div class="main-item">
        <router-link to="campus"
                     class="item-span">{{$t('join_social.text3')}}</router-link>
      </div>
    </div>
    <div class="template-content">
      <section class="section-header">
        <div class="header-main">
          <div class="header-title">{{$t('join_social.text4')}}</div>
          <div class="header-subtitle">
            <!-- <span class="sub-item">
              <img style="width: 27px;"
                   src="/static/images/about/tel.png"
                   alt="telphone">联系电话： 010-58650993</span>
            <br class="show-br" /> -->
            <span class="sub-item">
              <img src="/static/images/about/email.png"
                   alt="email">{{$t('join_social.text5')}}</span>
          </div>
        </div>
      </section>
      <section class="section-content">
        <div class="content-main">
          <div class="main-body">
            <div class="main-item">
              <div class="item-main"
                   v-for="(item, index) in $t('join_social.jobList')"
                   :key="index"
                   @click="getJobDetail(item)">
                <img class="hot-img"
                     :style="{'visibility': item.hot ? 'visible' : 'hidden'}"
                     src="/static/images/about/join/hot.png"
                     alt="火热招聘中">
                <span class="item-span">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <job-detail v-if="dialogVisible"
                :id="jobId"
                @closeDialog="closeDialog"></job-detail>
  </div>
</template>

<script>
import JobDetail from "./detail";
export default {
  data () {
    return {
      dialogVisible: false,
      jobId: "",
      typeList: [
        {
          id: "1",
          name: "研发"
        },
        {
          id: "2",
          name: "销售"
        },
        {
          id: "3",
          name: "安卓"
        },
        {
          id: "4",
          name: "IOS"
        },
        {
          id: "5",
          name: "测试"
        },
        {
          id: "6",
          name: "行政"
        },
        {
          id: "7",
          name: "飞手"
        },
        {
          id: "8",
          name: "人事专员"
        },
        {
          id: "9",
          name: "财务"
        },
        {
          id: "10",
          name: "产品经理"
        },
        {
          id: "11",
          name: "项目经理"
        }
      ],
      cityList: [
        {
          id: "1",
          name: "北京"
        },
        {
          id: "2",
          name: "上海"
        },
        {
          id: "3",
          name: "广州"
        },
        {
          id: "4",
          name: "深圳"
        },
        {
          id: "5",
          name: "武汉"
        },
        {
          id: "6",
          name: "西安"
        },
        {
          id: "7",
          name: "南京"
        },
        {
          id: "8",
          name: "杭州"
        },
        {
          id: "9",
          name: "郑州"
        },
        {
          id: "10",
          name: "长沙"
        },
        {
          id: "11",
          name: "石家庄"
        }
      ],
      
    };
  },
  methods: {
    getJobDetail (item) {
      this.dialogVisible = true;
      this.jobId = item.id;
    },
    closeDialog () {
      this.dialogVisible = false;
    }
  },
  components: {
    JobDetail
  }
};
</script>

<style lang='stylus' scoped>
.template-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  background: #f2f9ff;

  .template-header {
    display: block;
    height: 66px;
    line-height: 66px;
    background: #244E84;
    display: flex;
    justify-content: center;

    .main-item {
      width: 160px;
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;

      .item-span {
        padding: 10px;
        color: #fff;
      }

      .item-active {
        border-bottom: 2px solid #fff;
      }
    }
  }

  .template-content {
    // width: 80%;
    // max-width: 1280px;
    // margin: 0 auto;
    .section-header {
      .header-main {
        text-align: center;

        .header-title {
          font-size: 66px;
          font-weight: 500;
          color: #111111;
          padding-top: 100px;
        }

        .header-subtitle {
          height: 30px;
          line-height: 30px;
          padding: 20px 0;

          .sub-item {
            vertical-align: top;

            img {
              vertical-align: top;
            }
          }
        }

        .header-search {
          height: 54px;
          line-height: 54px;
          padding-top: 80px;
          padding-bottom: 30px;

          .search-main {
            width: 80%;
            max-width: 624px;
            height: 100%;
            margin: 0 auto;
            position: relative;

            .search-input {
              width: 100%;
              height: 100%;
              background: #FCFCFC;
              border-radius: 54px;
              border: 2px solid #EBEBEB;
              box-sizing: border-box;
              outline: none;
              text-indent: 36px;
              font-size: 18px;
            }

            .search-img {
              height: 46px;
              position: absolute;
              right: 4px;
              top: 4px;
            }
          }
        }
      }
    }

    .section-content {
      .content-header {
        .header-item {
          &:nth-child(1) {
            margin-bottom: 5px;
          }

          display: flex;
          padding: 20px 40px;
          background: #F2F9FF;

          .item-label {
            width: 160px;
            max-height: 42px;
            font-size: 18px;
            font-weight: 600;
            color: #111111;
            line-height: 42px;
            border-right: 2px solid #fff;
            box-sizing: border-box;
          }

          .item-value {
            flex: 1;
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            color: #111111;
            line-height: 22px;

            .value-span {
              display: inline-block;
              width: 90px;
              text-align: center;
              padding: 10px 0;
              cursor: pointer;
            }

            .span-active {
              color: #007BE7;
            }
          }
        }
      }

      .content-main {
        margin: 20px 0;

        .main-body {
          padding-bottom: 100px;
          background: #F2F9FF;

          .main-item {
            width: 1280px;
            margin: 0 auto;
            background-color: #F3F6F9;
            border: 1px dashed #E2E2E2;

            .item-main {
              display: inline-block;
              width: 414px;
              line-height: 38px;
              padding: 16px 14px;
              background: #fff;
              box-sizing: border-box;
              margin: 6px;
              cursor: pointer;

              .hot-img {
                width: 38px;
                height: 38px;
                vertical-align: top;
              }

              .item-span {
                font-size: 16px;
                font-weight: 400;
                color: #111111;
                line-height: 38px;
                padding-left: 10px;
                vertical-align: top;
              }
            }
          }
        }
      }
    }
  }

  .show-br {
    display: none;
  }
}

// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .template-container {
    .template-header {
      display: none;
    }

    .template-content {
      width: 100%;
      max-width: 100%;
      margin: 0 auto;

      .section-header {
        .header-main {
          text-align: center;

          .header-title {
            font-size: 36px;
            padding-top: 50px;
          }

          .header-search {
            height: 34px;
            line-height: 34px;
            padding-top: 80px;
            padding-bottom: 30px;

            .search-main {
              .search-input {
                border-radius: 34px;
                border: 1px solid #EBEBEB;
                text-indent: 24px;
                font-size: 16px;
              }

              .search-img {
                height: 26px;
                right: 4px;
                top: 4px;
              }
            }
          }
        }
      }

      .section-content {
        .content-header {
          .header-item {
            flex-direction: column;
            padding: 0 20px;

            .item-label {
              width: 100%;
              border-right: none;
            }

            .item-value {
            }
          }
        }

        .content-main {
          .main-body {
            .main-item {
              width: calc(100% - 40px);
              margin: 0 auto;

              .item-main {
                display: block;
                width: 100%;
                line-height: 38px;
                padding: 16px 14px;
                background: #fff;
                box-sizing: border-box;
                margin: 5px 0;
                cursor: pointer;

                &:nth-child(3n + 1) {
                  margin-left: 0;
                }

                .hot-img {
                  width: 38px;
                  height: 38px;
                  vertical-align: top;
                }

                .item-span {
                  font-size: 16px;
                  font-weight: 400;
                  color: #111111;
                  line-height: 38px;
                  padding-left: 10px;
                  vertical-align: top;
                }
              }
            }
          }
        }
      }
    }

    .show-br {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/join/social.vue